import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  IAdvisoryPurchasePaginatedResponse,
  getAdvisoryPurchasePaginated,
} from "api";
import { Nullable } from "config";
import { store } from "store";

import { AdvisoryPurchaseModalMode } from "./enums";
import { IAdvisoryPurchaseModalData } from "./types";

const initialState = {
  advisoryPurchaseData: null as Nullable<
    IAdvisoryPurchasePaginatedResponse["edges"]
  >,
  totalCount: 1,
  loading: false,
  modalData: {
    mode: AdvisoryPurchaseModalMode.VIEW,
    open: false,
    loading: false,
  } as IAdvisoryPurchaseModalData,
};

export const fetchAdvisoryPurchaseList = createAsyncThunk(
  "advisory/fetchAdvisoryPurchaseList",
  async () => {
    const filters = store.getState().FiltersReducer;
    if (!Object.values(filters).length) {
      return;
    }
    const response = await getAdvisoryPurchasePaginated(filters);
    return response;
  }
);

const advisoryPurchaseSlice = createSlice({
  name: "advisoryPurchase",
  initialState,
  reducers: {
    setAdvisoryPurchaseModalData: (
      state,
      action: PayloadAction<IAdvisoryPurchaseModalData>
    ) => {
      state.modalData = action.payload;
    },
    closeAdvisoryPurchaseModal: (state) => {
      state.modalData = initialState.modalData;
    },
    setAdvisoryPurchaseModalLoading: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.modalData.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAdvisoryPurchaseList.fulfilled, (state, action) => {
      if (!action.payload) return;
      return {
        ...state,
        advisoryPurchaseData: action.payload
          ?.edges as IAdvisoryPurchasePaginatedResponse["edges"],
        totalCount: action.payload?.totalCount,
        loading: false,
      };
    });
    builder.addCase(fetchAdvisoryPurchaseList.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
  },
});

export const {
  setAdvisoryPurchaseModalData,
  closeAdvisoryPurchaseModal,
  setAdvisoryPurchaseModalLoading,
} = advisoryPurchaseSlice.actions;

export default advisoryPurchaseSlice.reducer;
